// @mui
import { Popover } from '@mui/material';
import { styled } from '@mui/material/styles';

// ----------------------------------------------------------------------

const ArrowStyle = styled('span')(({ theme }) => {
  const SIZE = 10;

  const POSITION = -5.5;

  const borderStyle = `solid 1px ${theme.palette.grey[500_12]}`;

  return {
    zIndex: 1,
    width: SIZE,
    height: SIZE,
    content: "''",
    position: 'absolute',

    transform: 'rotate(-135deg)',
    background: theme.palette.background.paper,

    borderRadius: '0 0 2px 0',
    top: POSITION,
    borderBottom: borderStyle,
    borderRight: borderStyle,
    left: theme.spacing(15),
  };
});

export default function CoreTimePopoverComponent({ children, sx, ...other }) {
  const anchorOrigin = {
    vertical: 'bottom',
    horizontal: 'right',
  };

  const transformOrigin = {
    vertical: 'top',
    horizontal: 'center',
  }

  return (
    <Popover
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      PaperProps={{
        sx: {
          mt: 2,
          p: 1,
          overflow: 'inherit',
          ...sx,
        },
      }}
      {...other}
    >
      <ArrowStyle />
      {children}
    </Popover>
  );
}
